export default __webpack_public_path__ + "static/media/Curriki_Subscription_Agreement.560899c1.pdf";